module.exports = __webpack_public_path__ + "static/img/10.9955d6ed.png";